import { render, staticRenderFns } from "./RulesLabelButton.vue?vue&type=template&id=39d6a294&"
import script from "./RulesLabelButton.vue?vue&type=script&lang=js&"
export * from "./RulesLabelButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports